import { REFRESH_PERSON, REFRESH_HINTS } from '../../app/constants/exposed-methods';

/**
 * Creates public API methods (refreshPerson, refreshHints) that broadcast
 * update events to all registered Eval app instances.
 *
 * @param {Object<string, {update: Function}>} instances - Map of element IDs to app instances
 * @returns {{refreshPerson: Function, refreshHints: Function}} Public methods for cross-communication
 */
function exposeMethods(instances) {
	function execute(type, payload) {
		Object.keys(instances).forEach(key => {
			instances[key].update({ type, payload });
		});
	}
	return {
		refreshPerson: data => { execute(REFRESH_PERSON, data); },
		refreshHints: data => { execute(REFRESH_HINTS, data); }
	};
}

export default exposeMethods;
